
import {throwError as observableThrowError, Observable} from 'rxjs';

import {map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

const API_URL = 'https://era.esplac.cat/api';
//const API_URL = 'http://localhost:3000/api';


@Injectable()
export class CercaService {

  constructor(
    private http: HttpClient,
  ) {
  }


  // API: GET /esplais/cercador/:tipus/:terme
  public cercaEsplais(tipus, terme): Observable<any> {
    return this.http
    .get(API_URL + '/esplais/cercador/' + tipus + '/' + terme).pipe(
      map((r: any) => {
        if (r.status) { return r.data; } else { return false; }
      }),
      catchError(this.handleError),
    );
  }

  public cercaEsplaisUnificat(terme): Observable<any> {
    return this.http
    .get(API_URL + '/esplais/cercador', { params: terme}).pipe(
      map((r:any) => {
        if (r.status) { return r.data; } else {return false; }
      }),
      catchError(this.handleError),
    )
  }

  // API: GET /esplais/cercador/:tipus/:terme
  public cercaActuacions(tipus, inici, final): Observable<any> {
    return this.http
    .post(API_URL + '/actuacions/cercador/', {
      tipus,
      inici: inici, final: final}).pipe(
      map((r: any) => {
        if (r.status) { return r.data; } else { return false; }
      }),
      catchError(this.handleError),
    );
  }

  // API: GET /sectors/dropdown/actius
  public getDropdown(): Observable<any> {
    return this.http
      .get(API_URL + '/sectors/dropdown').pipe(
        map((r: any) => {
          if (r.status) {
            return r.data;
          } else {
            throw r.err;
          }
        }),
        catchError(this.handleError),
      );
  }

  private handleError(error: Response | any) {
    console.error('CercaService::errorHandler', error);
    if (error instanceof HttpErrorResponse) {
      if (!navigator.onLine) {
        return observableThrowError('No tens accés a internet.');
      } else if (error.status === 401) {
        console.error('Authentication Error');
        return;
      } else {
        return observableThrowError(error.message);
      }

    } else if (error instanceof TypeError) {
      return observableThrowError('TypeError');
    } else {
      // Error propi del status del json
      return observableThrowError(error);
    }
  }
}
